import { render, staticRenderFns } from "./IntegratedModelView.vue?vue&type=template&id=72fe3ec6&scoped=true"
import script from "./IntegratedModelView.vue?vue&type=script&lang=js"
export * from "./IntegratedModelView.vue?vue&type=script&lang=js"
import style0 from "./IntegratedModelView.vue?vue&type=style&index=0&id=72fe3ec6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fe3ec6",
  null
  
)

export default component.exports